import { restClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'

const q = (p: Record<string, unknown>) => new URLSearchParams(
  Object.entries(p).filter(([, v]) => v !== undefined && v !== null && v !== '').reduce((a, [k, v]) => ({ ...a, [k]: String(v) }), {})
).toString()

export const packageService = {
  list: (p: { page?: number; limit?: number; search?: string; school_id?: number; vendor_id?: number | string; is_published?: number | string; number_of_sessions?: number | string } = {}) => {
    const params: Record<string, unknown> = { page: p.page ?? 1, limit: p.limit ?? 15, locale: 'en' }
    if (p.search) params.search = p.search
    if (p.school_id) params.school_id = p.school_id
    if (p.vendor_id !== undefined && p.vendor_id !== '') params.vendor_id = p.vendor_id
    if (p.is_published !== undefined && p.is_published !== '') params.is_published = p.is_published
    if (p.number_of_sessions) params.number_of_sessions = p.number_of_sessions
    return restClient.get(`${endpoints.package.list}?${q(params)}`).then(r => r.data)
  },
  getById:    (id: number) => restClient.get(`${endpoints.package.details}${id}`).then(r => r.data),
  delete:     (id: number) => restClient.delete(`${endpoints.package.delete}${id}`).then(r => r.data),
  createUpdate:(data: Record<string, unknown>) => restClient.post(endpoints.package.createUpdate, data).then(r => r.data),
  bulkUpdate: (data: Record<string, unknown>[]) => restClient.post(endpoints.package.bulkUpdate, { packages: data }).then(r => r.data),
  // Bulk edit selected packages — posts { package_ids, ...changedFields } (matches old bulkUpdatePackage)
  bulkEdit:   (data: Record<string, unknown>) => restClient.post(endpoints.package.bulkUpdate, data).then(r => r.data),
}
